import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { CardBatch, MemberCategory, SchemaOption } from '../models/card-batches.model';

// ─── Load lookup data ──────────────────────────────────────────────────────────
export const LoadCardBatchesData = createAction('[Schemas: Card Batches]: Load Data');

export const GetMemberCategoriesSuccess = createAction(
  '[Schemas: Card Batches]: Get Member Categories Success',
  props<{ memberCategories: MemberCategory[] }>(),
);
export const GetMemberCategoriesFailed = createAction(
  '[Schemas: Card Batches]: Get Member Categories Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCardTypesSuccess = createAction(
  '[Schemas: Card Batches]: Get Card Types Success',
  props<{ cardTypes: string[] }>(),
);
export const GetCardTypesFailed = createAction(
  '[Schemas: Card Batches]: Get Card Types Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetSchemasSuccess = createAction(
  '[Schemas: Card Batches]: Get Schemas Success',
  props<{ schemas: SchemaOption[] }>(),
);
export const GetSchemasFailed = createAction(
  '[Schemas: Card Batches]: Get Schemas Failed',
  props<{ error: HttpErrorResponse }>(),
);

// ─── Search ────────────────────────────────────────────────────────────────────
export const SearchCardBatches = createAction('[Schemas: Card Batches]: Search');

export const SearchCardBatchesSuccess = createAction(
  '[Schemas: Card Batches]: Search Success',
  props<{ batches: CardBatch[] }>(),
);
export const SearchCardBatchesFailed = createAction(
  '[Schemas: Card Batches]: Search Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ClearCardBatchSearch = createAction('[Schemas: Card Batches]: Clear Search');

// ─── Filter fields ─────────────────────────────────────────────────────────────
export const CardBatchSchemaChanged = createAction(
  '[Schemas: Card Batches]: Schema Filter Changed',
  props<{ loyaltySchemaId: number | null }>(),
);

export const CardBatchPanelStatusChanged = createAction('[Schemas: Card Batches]: Panel Status Changed');

// ─── Sidenav ───────────────────────────────────────────────────────────────────
export const OpenCardBatchSidenav = createAction('[Schemas: Card Batches]: Open Sidenav');
export const CloseCardBatchSidenav = createAction('[Schemas: Card Batches]: Close Sidenav');

// ─── Create form fields ────────────────────────────────────────────────────────
export const CreateSchemaChanged = createAction(
  '[Schemas: Card Batches]: Create Schema Changed',
  props<{ schemaId: number | null }>(),
);
export const CreateMemberCategoryChanged = createAction(
  '[Schemas: Card Batches]: Create Member Category Changed',
  props<{ memberCategoryId: number | null }>(),
);
export const CreateCardTypeChanged = createAction(
  '[Schemas: Card Batches]: Create Card Type Changed',
  props<{ cardType: string | null }>(),
);
export const CreateBatchSizeChanged = createAction(
  '[Schemas: Card Batches]: Create Batch Size Changed',
  props<{ batchSize: string }>(),
);
export const CreateCardPrefixChanged = createAction(
  '[Schemas: Card Batches]: Create Card Prefix Changed',
  props<{ cardPrefix: string }>(),
);
export const CreateRemarksChanged = createAction(
  '[Schemas: Card Batches]: Create Remarks Changed',
  props<{ remarks: string }>(),
);
export const ResetCreateForm = createAction('[Schemas: Card Batches]: Reset Create Form');

// ─── Submit create ─────────────────────────────────────────────────────────────
export const SubmitCreateCardBatch = createAction('[Schemas: Card Batches]: Submit Create');
export const CreateCardBatch = createAction('[Schemas: Card Batches]: Create Card Batch');
export const SetSubmitted = createAction('[Schemas: Card Batches]: Set Submitted');

export const CreateCardBatchSuccess = createAction('[Schemas: Card Batches]: Create Card Batch Success');
export const CreateCardBatchFailed = createAction(
  '[Schemas: Card Batches]: Create Card Batch Failed',
  props<{ error: HttpErrorResponse }>(),
);

// ─── Store full batches result for client-side pagination ─────────────────────
export const StoreBatches = createAction('[Schemas: Card Batches]: Store Batches', props<{ batches: CardBatch[] }>());
export const DownloadCardBatch = createAction('[Schemas: Card Batches]: Download', props<{ cardBatchId: number }>());
export const DownloadCardBatchSuccess = createAction('[Schemas: Card Batches]: Download Success');
export const DownloadCardBatchFailed = createAction(
  '[Schemas: Card Batches]: Download Failed',
  props<{ error: HttpErrorResponse }>(),
);
